var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-list-item',{staticClass:"mb-0 justify-space-between pl-3"},[_c('v-list-item-avatar',[_c('v-img',{attrs:{"src":require('@/assets/nexo.png')}})],1),_c('v-list-item-content',{staticClass:"pl-2"},[_c('v-list-item-title',{staticClass:"text-h3"},[_c('img',{attrs:{"src":require("@/assets/logo.png"),"width":"150"}})])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }